export const aboutData = {
    title: "Who am I ?",
    description1: "Hello! My name is Gaurav Bansal. I'm a MERN stack developer based in India.",
    description2: "Also, I am a 3rd year undergraduate student at Delhi Technological University. I am proficient in Data Structures and Algorithms in C++ and have good knowledge of JavaScript as well.",
    image: 2
}